(() => {
  if (customElements.get('coko-monkey')) return;
  class CokoMonkey extends HTMLElement {
    connectedCallback() {
      this.gaze = this.querySelectorAll('.monkey-gaze');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.visible = false;
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; if (!this.visible) this.rest(); });
      this.observer.observe(this);
      this.play = this.querySelector('.monkey-play');
      this.staticArt = this.querySelector('.monkey-static');
      this.reply = this.querySelector('.monkey-reply');
      this.allow = () => this.hasAttribute('data-animate') && !this.motion.matches;
      this.sync = () => { const enabled = this.hasAttribute('data-animate') && (!!this.reply || !this.motion.matches); if (this.reply) this.reply.hidden = !enabled; if (this.play) { this.play.hidden = !enabled; this.staticArt.hidden = enabled; } this.rest(); };
      this.motion.addEventListener('change', this.sync, options);
      this.sync();
      this.move = event => {
        if (!this.allow() || !this.visible || document.hidden || event.pointerType === 'touch') return;
        this.pointer = { x: event.clientX, y: event.clientY };
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          if (!this.visible || !this.allow()) return;
          const r = this.getBoundingClientRect();
          const dx = this.pointer.x - (r.left + r.width / 2);
          const dy = this.pointer.y - (r.top + r.height * .51);
          const length = Math.hypot(dx, dy) || 1;
          const amount = Math.min(length / Math.max(r.width, 100), 1);
          this.look(dx / length * amount * 32, dy / length * amount * 22);
        });
      };
      document.addEventListener('pointermove', this.move, { ...options, passive: true });
      document.documentElement.addEventListener('pointerleave', () => this.rest(), options);
      window.addEventListener('blur', () => this.rest(), options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) this.rest(); }, options);
      this.play?.addEventListener('click', () => {
        if (!this.hasAttribute('data-animate')) return;
        clearTimeout(this.resetTimer); clearTimeout(this.blinkTimer);
        this.turn = (this.turn || 0) + 1;
        if (this.reply) this.reply.textContent = ['I saw you looking.', 'Good taste. Carry on.', 'Go on. Be a little extra.'][(this.turn - 1) % 3];
        if (!this.allow()) return;
        this.look(this.turn % 2 ? 30 : -30, -12);
        this.classList.add('is-blinking');
        this.blinkTimer = setTimeout(() => this.classList.remove('is-blinking'), 240);
        this.resetTimer = setTimeout(() => this.rest(), 1100);
      }, options);
    }
    look(x,y) { this.style.setProperty('--gaze-x', x.toFixed(2) + 'px'); this.style.setProperty('--gaze-y', y.toFixed(2) + 'px'); }
    rest() { cancelAnimationFrame(this.frame); this.frame = 0; clearTimeout(this.resetTimer); clearTimeout(this.blinkTimer); this.classList.remove('is-blinking'); this.look(0,0); }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); this.rest(); }
  }
  customElements.define('coko-monkey', CokoMonkey);
})();

/* A single visible mascot travels from the hero into the sticky header. */
(() => {
  let dispose = () => {};
  function setup() {
    dispose();
    const body = document.body;
    const hero = document.querySelector('.hero-monkey');
    const header = document.querySelector('.site-header .brand coko-monkey');
    if (!body.classList.contains('template-index') || !hero || !header) return;
    const source = hero.querySelector('.monkey-play:not([hidden]) .monkey-art, .monkey-static:not([hidden]) .monkey-art');
    const destination = header.querySelector('.monkey-art');
    if (!source || !destination) return;
    const play = hero.querySelector('.monkey-play');
    const wordmark = document.querySelector('.site-header .brand .wordmark');
    if (!wordmark) return;
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 750px)');
    const controller = new AbortController();
    const fly = document.createElement('div');
    fly.className = 'monkey-transfer-fly';
    fly.setAttribute('aria-hidden', 'true');
    fly.hidden = true;
    fly.appendChild(source.cloneNode(true));
    document.querySelector('.site-header').appendChild(fly);
    let frame = 0;
    function update() {
      frame = 0;
      if (!hero.isConnected || !header.isConnected) { dispose(); return; }
      const a = source.getBoundingClientRect();
      const headerBottom = document.querySelector('.site-header').getBoundingClientRect().bottom;
      body.classList.toggle('monkey-mobile-transfer', mobile.matches);
      if (mobile.matches) {
        if (body.classList.contains('monkey-transfer-away')) body.classList.remove('monkey-transfer-away');
        body.classList.toggle('monkey-in-header', a.bottom <= headerBottom);
        if (play?.hasAttribute('tabindex')) play.removeAttribute('tabindex');
        fly.hidden = true;
        return;
      }
      const b = destination.getBoundingClientRect();
      if (!a.width || !b.width) return;
      const sourceDocumentTop = a.top + window.scrollY;
      const start = Math.max(0, sourceDocumentTop - headerBottom - 8);
      const end = start + 260;
      let amount = Math.max(0, Math.min(1, (window.scrollY - start) / (end - start)));
      if (play && play.matches(':focus-visible')) amount = 0;
      const progress = reduced.matches ? (amount >= 1 ? 1 : 0) : amount;
      const moving = progress > 0 && progress < 1;
      body.classList.toggle('monkey-transfer-away', progress > 0);
      body.classList.toggle('monkey-in-header', progress >= 1);
      if (play) play.tabIndex = progress > 0 ? -1 : 0;
      fly.hidden = !moving;
      if (moving) {
        const w = wordmark.getBoundingClientRect();
        const smooth = value => { const t = Math.max(0, Math.min(1, value)); return t * t * (3 - 2 * t); };
        const lerp = (from, to, t) => from + (to - from) * t;
        const safeLeft = Math.max(0, w.left - b.width - 8);
        const safeBelow = w.bottom + 8;
        const startTop = sourceDocumentTop - start;
        let scale, x, y;
        if (progress < .45) {
          const t = smooth(progress / .45);
          scale = lerp(1, b.width / a.width, t);
          x = lerp(a.left, safeLeft, t);
          y = lerp(startTop, safeBelow, t);
        } else if (progress < .8) {
          const t = smooth((progress - .45) / .35);
          scale = b.width / a.width;
          x = safeLeft;
          y = lerp(safeBelow, b.top, t);
        } else {
          const t = smooth((progress - .8) / .2);
          scale = b.width / a.width;
          x = lerp(safeLeft, b.left, t);
          y = b.top;
        }
        fly.style.width = a.width + 'px';
        fly.style.height = a.height + 'px';
        fly.style.transform = `translate3d(${x}px,${y}px,0) scale(${scale})`;
      }
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    dispose = () => {
      controller.abort(); cancelAnimationFrame(frame); fly.remove();
      body.classList.remove('monkey-transfer-ready', 'monkey-transfer-away', 'monkey-in-header', 'monkey-mobile-transfer');
      if (play) play.removeAttribute('tabindex');
    };
    window.addEventListener('scroll', schedule, { passive: true, signal: controller.signal });
    window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
    reduced.addEventListener('change', schedule, { signal: controller.signal });
    play?.addEventListener('focusin', schedule, { signal: controller.signal });
    play?.addEventListener('focusout', schedule, { signal: controller.signal });
    body.classList.add('monkey-transfer-ready');
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();


/* Occasional blinks only for the currently visible, motion-enabled mascot. */
(() => {
  let dispose = () => {};
  function setup() {
    dispose();
    const controller = new AbortController();
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const states = [...document.querySelectorAll('coko-monkey[data-animate]')].map(monkey => ({ monkey, visible: false, timer: 0, endTimer: 0 }));
    if (!states.length) return;
    const clear = state => {
      clearTimeout(state.timer); clearTimeout(state.endTimer);
      state.timer = 0; state.endTimer = 0;
      state.monkey.classList.remove('is-idle-blinking');
    };
    const eligible = state => {
      if (!state.visible || document.hidden || motion.matches || !state.monkey.isConnected) return false;
      const art = state.monkey.querySelector('.monkey-play:not([hidden]) .monkey-art, .monkey-static:not([hidden]) .monkey-art') || state.monkey.querySelector('.monkey-art');
      return !!art && art.getClientRects().length > 0 && getComputedStyle(art).visibility === 'visible';
    };
    function sync(state) {
      if (!eligible(state)) { clear(state); return; }
      if (state.timer || state.endTimer) return;
      state.timer = setTimeout(() => {
        state.timer = 0;
        if (!eligible(state)) return;
        if (state.monkey.classList.contains('is-blinking')) { sync(state); return; }
        state.monkey.classList.add('is-idle-blinking');
        state.endTimer = setTimeout(() => {
          state.endTimer = 0;
          state.monkey.classList.remove('is-idle-blinking');
          sync(state);
        }, 250);
      }, 7000 + Math.random() * 8000);
    }
    const syncAll = () => states.forEach(sync);
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { const state = states.find(item => item.monkey === entry.target); if (state) { state.visible = entry.isIntersecting; sync(state); } });
    });
    const classes = new MutationObserver(syncAll);
    classes.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    states.forEach(state => {
      observer.observe(state.monkey);
      state.monkey.querySelector('.monkey-play')?.addEventListener('click', () => { clear(state); sync(state); }, { capture: true, signal: controller.signal });
    });
    document.addEventListener('visibilitychange', syncAll, { signal: controller.signal });
    motion.addEventListener('change', syncAll, { signal: controller.signal });
    dispose = () => { controller.abort(); observer.disconnect(); classes.disconnect(); states.forEach(clear); };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
